import { createSuppressionStore } from "./createSuppressionStore";

const chatWidgetSuppression = createSuppressionStore();

export const useChatWidgetSuppressed = chatWidgetSuppression.useSuppressed;

export const useSuppressChatWidget = chatWidgetSuppression.useSuppress;
